import styled from 'styled-components';

const StyledBreadcrumbText = styled('div')(({ theme }: any) => ({
  fontSize: theme.fontSize.lg,
  fontWeight: theme.fontWeight.medium,
  color: theme.color.gray9,
}));

const BreadcrumbSeparator = styled('span')(({ theme }: any) => ({
  color: theme.color.gray6,
}));

export { StyledBreadcrumbText, BreadcrumbSeparator };
